import React, { useEffect, useState, useRef } from "react";
import "./typography.css";
import PersonalDetailsForm from "./Components/LeadCaptureForm/PersonalDetailsForm";
import StepWizard from "react-step-wizard";
import Spinner from "./Components/Spinner/spinner";
import { useSearchParams } from "react-router-dom";
import { setUserClickData } from "../../utility/setUserClickData";
import { loadGtm } from "./Utils/GtmLoader";
import { login, setOffers } from "../../store/app/appReducer";
import { useDispatch } from "react-redux";
import callApi from "../../utility/apiCaller";
import { v6 as uuid } from 'uuid';
import HomeLoanConfirmation from "./Components/LeadCaptureForm/HomeLoanConfirmation";
import BalanceTransferOptions from "./Components/LeadCaptureForm/BalanceTransferOptions";
import FindingOffersLoading from "./Components/FindingOffersLoading/FindingOffersLoading";
import LoanOfferSelection from "./Components/LoanOfferSelection/LoanOfferSelection";
import ThankYouSuccess from "./Components/ThankYouSuccess/ThankYouSuccess";
import {
  setAmountRequired,
  setAppId,
  setEmendateUrl,
  setInternalLead,
  setKfsUrl,
  setKycurl,
  setLeadId,
  setOpportunityId,
  setOpportunityName,
  setResponse,
  setUserData,
} from "../../store/app/aaSlice";
import MobileOtpPage from "./Components/LeadCaptureForm/MobileOtpPage";

export default function LandingPage() {
  useEffect(() => {
    loadGtm("GTM-KNNN2HFK");
  }, []);

  const stepWizardRef = useRef(null);
  const [isFormStarted, setIsFormStarted] = useState(false); 
  const [currentStep, setCurrentStep] = useState(null);
  
  const __goldPreview =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("ui") === "gold";
  useEffect(() => {
    if (__goldPreview && currentStep !== 56) setCurrentStep(56);
  }, [__goldPreview, currentStep]);
  const [formData, setFormData] = useState({});
  const [params] = useSearchParams();
  const [mobile, setMobileForOtp] = useState("");
  const [loadingStep, setLoadingStep] = useState(true);
  let leadId; 
  const ldId = params.get("ld_id") || "";
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const affId = params.get("aff_id") || "";
  const utmSource = params.get("utm_source") || "";
  const source = params.get("source") || "";
  const utmMedium = params.get("utm_medium") || "";
  const utmTerm = params.get("utm_term") || "";
  const adsName = params.get("ads_name") || "";
  const [applicationid, setApplicationId] = useState(""); 
  const [lead_Id, setLead_Id] = useState(""); 
  const [responseId, setResponseId] = useState(""); 
  const [mappedData, setMappedData] = useState(null);
  const [aaUrl, setaaUrl] = useState(null);
  const [InternalLeadId, seInternalLeadId] = useState(null);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [status, setStatus] = useState(null);

  const [addressState, setAddressState] = useState({
    residenceAddress: "",
    residenceWingFloorFlat: "",
    residenceBuildingName: "",
    residenceYears: "",
    residenceMonths: "",
    residence_type: "",
    permanentAddress: "",
    permanentaddressLine1: "",
    permanentaddressLine2: "",
    pincode: "",
    work_address1: "",
    work_address2: "",
    address1: "", 
    address2: "", 
  });

  useEffect(() => {
    const trackId = localStorage.getItem("track_id");
    setUserClickData({
      event_name: `page-preview-for-e2e`,
      user_id: ldId || "unknown",
      affiliate_id: affId || "No Aff_id found",
      utm_source: utmSource || utmMedium,
      utm_term: utmTerm,
    });
  }, []);

  useEffect(() => {
    console.log(addressState);
  }, [addressState]);

  function extractParams(url) {
    let lead_Id = null;
    let requestId = null;
    let status = null;

    try {
      if (!url.includes("?")) return { lead_Id, requestId, status };

      const [base, queryString] = url.split("?");
      if (!queryString) return { lead_Id, requestId, status };

      const queryParts = queryString.split("?");
      const lidPart = queryParts[0]; 
      const otherParamsPart = queryParts[1] || "";

      if (lidPart.includes("=")) {
        const [key, value] = lidPart.split("=");
        if (key === "lid") {
          lead_Id = value;
        }
      }

      if (otherParamsPart) {
        const otherParams = new URLSearchParams(otherParamsPart);
        status = otherParams.get("Status");
        requestId = otherParams.get("Request_ID");
      }
    } catch (error) {
      console.error("Error parsing URL:", error);
    }

    return { lead_Id, requestId, status };
  }

  useEffect(() => {
    const { lead_Id, requestId, status } = extractParams(window.location.href);

    if (!lead_Id) setCurrentStep(1);
    if (lead_Id) setLead_Id(lead_Id);
    if (requestId) setRequestId(requestId);
    if (status) setStatus(status);
  }, []);

  useEffect(() => {
    if (!lead_Id) return;
    checkAndCallApi();
  }, [lead_Id]);

  const checkAndCallApi = async () => {
    if (!lead_Id) return;

    try {
      setLoadingStep(true);

      const res = await callApi(
        "v1/lead/list",
        "post",
        {
          filters: { _id: lead_Id },
        },
        "core"
      );
      console.log(res);

      if (res.status === "Success" && res.data?.leadList.length > 0) {
        const {
          _id = "",
          steps_completed = 0,
          application_id = "",
          dmi_lead_response_id = "",
          dmi_lead_id = "",
          dmi_offer = "",
          dmi_opportunityid = "",
          amount_required,
          kycurl = "",
          emandateurl = "",
          dmi_opportunityName = "",
          dmi_offers_details,
          token,
        } = res.data.leadList[0];

        let startStep = 1;

        seInternalLeadId(lead_Id);
        dispatch(setInternalLead(_id));
        dispatch(setResponse(dmi_lead_response_id));
        dispatch(setAppId(application_id));
        dispatch(setLeadId(dmi_lead_id));
        dispatch(setOpportunityId(dmi_opportunityid));
        dispatch(setKycurl(kycurl));
        dispatch(setAmountRequired(amount_required));
        dispatch(setKfsUrl(res.data.leadList[0].kfsurl));
        dispatch(setUserData(res.data.leadList[0]));
        dispatch(setEmendateUrl(emandateurl));
        dispatch(setOpportunityName(dmi_opportunityName));
        dispatch(setOffers(dmi_offers_details));
        dispatch(
          login({
            token: token,
          })
        );

        if (!steps_completed || steps_completed === 0) {
          setCurrentStep(1);
        }
        if (steps_completed >= 3 && steps_completed <= 16 && steps_completed !== 5) {
          startStep = steps_completed + 1;
        }

        if (steps_completed === 5) {
          startStep = 55
        }

        setCurrentStep(startStep);

        setTimeout(() => {
          if (stepWizardRef.current) {
            stepWizardRef.current.goToStep(startStep);
          }
        }, 100);
      } else {
        setCurrentStep(1);
        throw new Error("Error while fetching data");
      }
    } catch (error) {
      console.error("Error calling API:", error);
    } finally {
      setLoadingStep(false);
    }
  };

  const dispatch = useDispatch();

  useEffect(() => {
  }, [formData]);

  useEffect(() => {
    const trackId = localStorage.getItem("track_id");
  }, []);

  const [formDataPostOffer, setFormDataPostOffer] = useState({});

  const nextStep = () => setCurrentStep((prev) => prev + 1);
  const goToPostOffer = () => setCurrentStep("post-offer");

  useEffect(() => {
    window.onbeforeunload = () => {
      sessionStorage.removeItem("isFormStarted");
    };

    const sessionFlag = sessionStorage.getItem("isFormStarted");
    if (sessionFlag === "true") {
      setIsFormStarted(true);
    }
    setUserClickData({
      event_name: "pageview-multistep-pl-v1",
      user_id: ldId,
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: utmSource || utmMedium,
      utm_term: utmTerm,
    });
  }, []);

  if (!currentStep) {
    return (
      <div className="min-h-screen w-full bg-[#f4f5f7] flex justify-center items-center">
        <div className="w-full max-w-[400px] min-h-[100dvh] bg-white sm:shadow-[0_0_40px_rgba(0,0,0,0.08)] flex justify-center items-center">
          <Spinner />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full bg-[#f4f5f7] flex justify-center">
      <div className="plv17-app w-full max-w-[400px] bg-white min-h-[100dvh] relative sm:shadow-[0_0_40px_rgba(0,0,0,0.08)] flex flex-col overflow-x-hidden overflow-y-auto no-scrollbar">
        {loadingStep && leadId ? (
          <div className="flex items-center justify-center h-screen">
            <Spinner />
            <p className="ml-2 text-gray-700">Loading your application...</p>
          </div>
        ) : (
          <>
            {currentStep === 1 && (
              <>
                <MobileOtpPage
                  isFormStarted={isFormStarted}
                  setIsFormStarted={() => {
                    sessionStorage.setItem("isFormStarted", "true");
                    setIsFormStarted(true);
                  }}
                  setCurrentStep={setCurrentStep}
                  currentStep={currentStep}
                  formData={formData}
                  setFormData={setFormData}
                />
              </>
            )}

            {currentStep === 2 && (
              <div className="w-full max-w-[400px]">
                <PersonalDetailsForm
                  formData={formData}
                  setFormData={setFormData}
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  isFormStarted={isFormStarted}
                  setIsFormStarted={setIsFormStarted}
                  setMobileForOTP={setMobileForOtp}
                />
              </div>
            )}

            {currentStep === 3 && (
              <div className="w-full max-w-[400px]">
                <HomeLoanConfirmation
                  formData={formData}
                  setCurrentStep={setCurrentStep}
                />
              </div>
            )}

            {currentStep === 4 && (
              <div className="w-full max-w-[400px]">
                <BalanceTransferOptions
                  formData={formData}
                  setFormData={setFormData}
                  setCurrentStep={setCurrentStep}
                />
              </div>
            )}
            
            {currentStep === 5 && (
              <div className="w-full max-w-[400px]">
                <FindingOffersLoading
                  formData={formData}
                  setCurrentStep={setCurrentStep}
                />
              </div>
            )}
            
            {currentStep === 6 && (
              <div className="w-full max-w-[400px]">
                <LoanOfferSelection
                  setCurrentStep={setCurrentStep}
                  selectedOffer={selectedOffer}
                  setSelectedOffer={setSelectedOffer}
                />
              </div>
            )}

            {currentStep === 7 && (
              <div className="w-full max-w-[400px]">
                <ThankYouSuccess
                  selectedOffer={selectedOffer}
                  formData={formData}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}